import React from 'react';
import Icon from 'components/AppIcon';

const GENDER_OPTIONS = [
  { value: '', label: 'Select gender' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'non_binary', label: 'Non-binary' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
];

export default function ProfileForm({ formData, onChange, errors, email }) {
  const handleChange = (field, value) => {
    onChange?.({ ...formData, [field]: value });
  };

  const inputClass = (field) =>
    `w-full px-3 py-2.5 rounded-[var(--radius-sm)] border text-sm font-[var(--font-body)] bg-[var(--color-input)] text-[var(--color-foreground)] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--color-ring)]/30 focus:border-[var(--color-primary)] ${
      errors?.[field]
        ? 'border-[var(--color-error)]'
        : 'border-[var(--color-border)] hover:border-[var(--color-primary)]/40'
    }`;

  return (
    <div className="space-y-5">
      {/* Personal Info */}
      <div>
        <h3 className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-heading)] mb-3 flex items-center gap-2">
          <Icon name="User" size={15} color="var(--color-primary)" />
          Personal Information
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-1">Full Name</label>
            <input
              type="text"
              value={formData?.fullName ?? ''}
              onChange={(e) => handleChange('fullName', e?.target?.value)}
              placeholder="Enter your full name"
              className={inputClass('fullName')}
            />
            {errors?.fullName && <p className="text-xs text-[var(--color-error)] mt-1">{errors?.fullName}</p>}
          </div>
          <div>
            <label className="block text-xs font-medium text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-1">Phone Number</label>
            <input
              type="tel"
              value={formData?.phone ?? ''}
              onChange={(e) => handleChange('phone', e?.target?.value)}
              placeholder="+1 (555) 000-0000"
              className={inputClass('phone')}
            />
            {errors?.phone && <p className="text-xs text-[var(--color-error)] mt-1">{errors?.phone}</p>}
          </div>
          <div>
            <label className="block text-xs font-medium text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-1">Date of Birth</label>
            <input
              type="date"
              value={formData?.dateOfBirth ?? ''}
              onChange={(e) => handleChange('dateOfBirth', e?.target?.value)}
              className={inputClass('dateOfBirth')}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-1">Gender</label>
            <select
              value={formData?.gender ?? ''}
              onChange={(e) => handleChange('gender', e?.target?.value)}
              className={inputClass('gender')}
            >
              {GENDER_OPTIONS?.map(opt => (
                <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      {/* Emergency Contact */}
      <div>
        <h3 className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-heading)] mb-3 flex items-center gap-2">
          <Icon name="Phone" size={15} color="var(--color-primary)" />
          Emergency Contact
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-1">Contact Name</label>
            <input
              type="text"
              value={formData?.emergencyContactName ?? ''}
              onChange={(e) => handleChange('emergencyContactName', e?.target?.value)}
              placeholder="Emergency contact name"
              className={inputClass('emergencyContactName')}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-1">Contact Phone</label>
            <input
              type="tel"
              value={formData?.emergencyContactPhone ?? ''}
              onChange={(e) => handleChange('emergencyContactPhone', e?.target?.value)}
              placeholder="+1 (555) 000-0000"
              className={inputClass('emergencyContactPhone')}
            />
          </div>
        </div>
      </div>
      {/* Read-only Email */}
      <div>
        <h3 className="text-sm font-semibold text-[var(--color-foreground)] font-[var(--font-heading)] mb-3 flex items-center gap-2">
          <Icon name="Mail" size={15} color="var(--color-primary)" />
          Account Email
        </h3>
        <div>
          <label className="block text-xs font-medium text-[var(--color-muted-foreground)] font-[var(--font-caption)] mb-1">Email Address</label>
          <div className="relative">
            <input
              type="email"
              value={email ?? ''}
              readOnly
              className="w-full px-3 py-2.5 pr-10 rounded-[var(--radius-sm)] border border-[var(--color-border)] text-sm font-[var(--font-body)] bg-[var(--color-muted)] text-[var(--color-muted-foreground)] cursor-not-allowed"
            />
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              <Icon name="Lock" size={14} color="var(--color-muted-foreground)" />
            </div>
          </div>
          <p className="text-xs text-[var(--color-muted-foreground)] mt-1 font-[var(--font-caption)]">
            Email changes require contacting support.
          </p>
        </div>
      </div>
    </div>
  );
}
